import { getAbTestCookie, getSession } from './cookie';
import { AdObj, RtbAdObj, NativeAdObj } from '../../shared/types/ast';

const allowedTakeoverTags = ['board_2'];
const horseShoeDivs = ['skyscraperleft_1', 'topboard', 'skyscraperright_1'];

function isHorseshoeElement(tagName: string, hasHorseshoe?: boolean) {
    return hasHorseshoe && horseShoeDivs.includes(tagName);
}

function isTakeover(tagName: string, adObj: RtbAdObj) {
    const isAllowedTag = allowedTakeoverTags.includes(tagName);
    return (
        isAllowedTag &&
        adObj.height &&
        adObj.width &&
        adObj.height === 3 &&
        adObj.width === 3
    );
}

function getNativeType(adObj: NativeAdObj) {
    if (adObj.native) {
        if (adObj.targetId === 'contentboard') {
            return 'contentboard';
        }
        if (adObj.native.desc2) {
            return adObj.native.desc2;
        }
        if (adObj.native.custom) {
            return adObj.native.custom.type;
        }
    }
    return '';
}

function getNativeBannerType(adObj: NativeAdObj) {
    const nativeType = getNativeType(adObj);
    const nativeTypeName = nativeType ? nativeType : 'netboard';
    return `native-${nativeTypeName}`;
}

export function getBannerType(
    tagName: string,
    adObj?: AdObj,
    hasHorseshoe?: boolean,
) {
    if (adObj) {
        switch (adObj.source) {
            case 'rtb':
                switch (adObj.adType) {
                    case 'banner':
                        if (isTakeover(tagName, adObj)) {
                            return 'banner-takeover';
                        } else if (isHorseshoeElement(tagName, hasHorseshoe)) {
                            return 'banner-horseshoe';
                        }
                        return 'banner';
                    case 'video':
                        return 'video';
                    case 'native':
                        return getNativeBannerType(adObj);
                    default:
                        return 'banner';
                }
            case 'csm':
                return 'banner';
        }
    }
    return 'banner';
}

export function getEcEventData(
    tagId: string,
    ele?: Element,
    vertical?: string,
    creativeId?: number,
    adObj?: AdObj,
    hasHorseshoe?: boolean,
) {
    const url = document.baseURI;
    let listPos: string | number = '';
    let finnkode: string | number = '';

    const creativeType = getBannerType(tagId, adObj, hasHorseshoe);

    if (ele && url && url.includes('/search.html')) {
        listPos = Number(ele.getAttribute('data-position-index'));
    } else if (url && url.includes('/ad.html')) {
        finnkode = Number(new URL(url).searchParams.get('finnkode'));
    }

    const eventData = {
        'extra.position': tagId,
        'extra.vertical': vertical,
        'extra.session': getSession(),
        'extra.creativeId': creativeId ? creativeId.toString() : '',
        'extra.creativeType': creativeType,
        'extra.pageurl': window.location.href,
        'extra.listPos': listPos.toString(),
        'extra.abtest': getAbTestCookie(),
        finnkode: finnkode.toString(),
    };

    return eventData;
}
